import _ from 'lodash-es';
import UAParser from 'ua-parser-js';

export default function v1Tailored() {
  const parser = new UAParser();
  const isIE = parser.getBrowser().name === 'IE';

  if (!isIE) {
    return;
  }

  const contentMaxWidth = 1280;
  const breakPoint = 1440;
  const elm1 = document.querySelectorAll('.v1-tailoredThings1__image1');
  const elm2 = document.querySelectorAll('.v1-tailoredThings2__image1');

  /**
   * IE11は`calc()`の入れ子に対応していないため、擬似的に再現します。
   * @param {Number} width
   * @return void;
   */
  const addStyle = width => {
    if (elm1.length) {
      Array.from(elm1).forEach(item => {
        const elm = item;
        const parentWidth = elm.parentNode.clientWidth;
        elm.style.width = `${width + parentWidth}px`;
      });
    }

    if (elm2.length) {
      Array.from(elm2).forEach(item => {
        const elm = item;
        const parentWidth = elm.parentNode.clientWidth;
        elm.style.width = `${width + parentWidth}px`;
        elm.style.left = `-${width}px`;
      });
    }
  };

  /**
   * 擬似的に再現した`calc()`の入れ子を除去します。
   * @return void;
   */
  const removeStyle = () => {
    if (elm1.length) {
      Array.from(elm1).forEach(item => {
        const elm = item;
        elm.style.width = '';
      });
    }

    if (elm2.length) {
      Array.from(elm2).forEach(item => {
        const elm = item;
        elm.style.width = '';
        elm.style.left = '';
      });
    }
  };

  window.addEventListener('load', () => {
    const windowOuterWidth = window.outerWidth;
    // `width: calc(100% + calc(calc(100vw - 1280px) / 2));`
    const offsetHalfWidth = (windowOuterWidth - contentMaxWidth) / 2;

    if (windowOuterWidth >= breakPoint) {
      addStyle(offsetHalfWidth);
    } else {
      removeStyle(offsetHalfWidth);
    }
  });

  window.addEventListener(
    'resize',
    _.debounce(e => {
      const windowOuterWidth = e.target.outerWidth;
      const offsetHalfWidth = (windowOuterWidth - contentMaxWidth) / 2;

      if (windowOuterWidth >= breakPoint) {
        addStyle(offsetHalfWidth);
      } else {
        removeStyle(offsetHalfWidth);
      }
    }, 300),
  );
}
